import React, { FC } from 'react';
import { AutomationsView } from '../components';

export const AutomationsPage: FC = () => {
  return <AutomationsView />;
};
